<template>
    <breadCrumbs title="Lists" main="UI Kits" title1="Lists" />
    <div class="container-fluid">
        <div class="row">
            <default12345Page/>
            <custom6789Page/>
            </div>
            </div>
</template>
<script>
import default12345Page from './default12345Page.vue';
import custom6789Page from './custom6789Page.vue'
    export default{
        name: 'ListsPage',
        components:{
            default12345Page,
            custom6789Page
        }
    }
</script>